import {MarginQuizQuestionController} from "./MarginQuizQuestionController";
import {MARGINED_CALL} from "../MarginQuizQuestions";
import {UserConfig} from "../../../types/UserConfig";
import {CurrentUserService} from "../../../services/user/CurrentUserService";

export const MarginCall = "tfMarginCallQuestion";

export function marginCall() {
    return {
        templateUrl: "app/quiz/margin/questions/MarginCall.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: MarginCallController
    };
}

export class MarginCallController extends MarginQuizQuestionController {

    public config = MARGINED_CALL;
    public isGame: boolean;

    /** @ngInject */
    public constructor(public currentUserService: CurrentUserService) {
        super();
        this.isGame = currentUserService.isGame();
    }
}
